<template>
  <div class="checkout-component">
    <div class="desc" v-html="get_word('apply_chackout_desc')"></div>
    <form v-if="!showPayment" @submit.prevent="addNames" class="name_form">
      <h5>פרטים לקבלה</h5>
      <ul>
        <li>
          <label for="">שם פרטי</label>
          <input type="text" name="first_name" v-model="nameForm.first_name">
        </li>
        <li>
          <label for="">שם משפחה</label>
          <input type="text" name="last_name" v-model="nameForm.last_name">
        </li>
        <li>
          <label for="">איימיל</label>
          <input type="email" name="email" v-model="nameForm.email">
        </li>
      </ul>
      <input type="submit" class="btn" value="שליחה" />
    </form>
    <Payment v-else :paymentData="paymentData" @payment_success="handlePaymentSuccess" @fail_msg="failMsg" @fail="fail" />
  </div>
</template>

<script>
import Payment from '@/components/Payment.vue';
export default {
  components: { Payment },
  props: {
    token: {
      type: [String, Boolean],
      required: true
    }
  },
  data() {
    return {
      paymentData: {},  
      showPayment: false,
      nameForm: {
        first_name: '',
        last_name: '',
        email: ''
      },
      order_token: null,
      apply_token: null
    }
  },
  created() {
    this.apply_token = this.token;
    // Get user information
    const [first_name, last_name] = this.get_me().name.split(' ');
    this.nameForm.first_name = first_name;
    this.nameForm.last_name = last_name;
    this.nameForm.email = this.get_me().username;
    
    // Create initial order to get order token
    this.createOrder();
  },
  methods: {
    createOrder() {
      this.api({ action: 'applying/create_order', data: { apply_token: this.apply_token }}, (data) => {
        if (data.data && data.data.order_token) {
          this.order_token = data.data.order_token;
        } else {
          this.$emit('fail', 'שגיאה ביצירת הזמנה');
        }
      });
    },
    addNames() {
      this.api({ action: 'order/update', data: { token: this.order_token, ...this.nameForm}}, (data) => {
        if (data.data) {
          this.createPayment();
        } else {
          this.$emit('fail', 'שגיאה בשמירת הנתונים');
        }
      });
    },
    failMsg(msg) {
      this.$emit('fail', msg);
    },
    fail() {
      this.$emit('fail', 'תשלום נכשל');
    },
    handlePaymentSuccess() {
      this.$emit('next');
    },
    createPayment() {
      this.api({ action: 'create_payment', data: { order_id: this.order_token }}, (obj) => {
        if (obj.data) {
          this.paymentData.id = obj.data.id;
          this.paymentData.price = obj.data.price;
          this.paymentData.first_name = this.nameForm.first_name;
          this.paymentData.last_name = this.nameForm.last_name;
          this.paymentData.email = this.nameForm.email;
          this.paymentData.invoice_name = this.nameForm.first_name + ' ' + this.nameForm.last_name;
          
          this.showPayment = true;
        } else {
          this.$emit('fail', 'שגיאה ביצירת תשלום');
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout-component {
  display: flex;
  flex-direction: column;
  gap: var(--gap_big);
  
  .name_form {
    display: flex;
    flex-direction: column;
    gap: var(--gap);
    
    ul {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
  }
}
</style> 